import { MapSearchInput, MobileMapSearchInput } from './MapSearchInput.js';

/**
 * Either a MapSearchInput, MobileMapSearchInput, or button that can be clicked to open a MobileMapSearchInput.
 */
export const MapSearchInputHolder = ({
    isLocationInputToggled,
    isMobile,
    setLocationInputToggle,
    selectedMarker,
    projectSearchResult,
    classroomEssentialsSearchResult,
    searchMarkers,
    showNearbyProjectsHelper,
    locationSearchBoxRef,
    performNewLocationSuggestionSearch,
    isLoadingProjectSearchResults,
    isLoadingEssentialsSearchResults,
    isLoadingSchoolSearchResults,
    performNewSearchOnMapCenter,
    numClassroomEssentialsInSearchRadius,
    showSearchBox,
    setSearchBox,
    searchParams,
    locationSearchParams
}) => {
    if (!isLocationInputToggled && isMobile) {
        return (
            <button
                className="button-secondary small heap-change-location-button"
                onClick={() => setLocationInputToggle(!isLocationInputToggled)}
            >Change location</button>
        );
    }

    const noFundableResults = (projectSearchResult || classroomEssentialsSearchResult) && searchMarkers && searchMarkers.length === 0;
    const isLoading = isLoadingProjectSearchResults || isLoadingEssentialsSearchResults || isLoadingSchoolSearchResults;

    if (isMobile) {
        return (
            <MobileMapSearchInput
                selectedMarker={selectedMarker}
                noFundableResults={noFundableResults}
                showNearbyProjectsHelper={showNearbyProjectsHelper}
                locationSearchBoxRef={locationSearchBoxRef}
                performNewLocationSuggestionSearch={performNewLocationSuggestionSearch}
                isLoading={isLoading}
                performNewSearchOnMapCenter={performNewSearchOnMapCenter}
                showSearchBox={showSearchBox}
                setSearchBox={setSearchBox}
                searchParams={searchParams}
                locationSearchParams={locationSearchParams}
                setLocationInputToggle={setLocationInputToggle}
            />
        );
    }

    return (
        <MapSearchInput
            selectedMarker={selectedMarker}
            noFundableResults={noFundableResults}
            showNearbyProjectsHelper={showNearbyProjectsHelper}
            locationSearchBoxRef={locationSearchBoxRef}
            performNewLocationSuggestionSearch={performNewLocationSuggestionSearch}
            isLoading={isLoading}
            performNewSearchOnMapCenter={performNewSearchOnMapCenter}
            showSearchBox={showSearchBox}
            setSearchBox={setSearchBox}
            searchParams={searchParams}
            locationSearchParams={locationSearchParams}
        />
    );
}
